// frontend/src/components/EdaPrepare/EdaPrepareStats.tsx

import React from 'react';

interface Props {
  analysis: any;
}

export const EdaPrepareStats: React.FC<Props> = ({ analysis }) => {
  const stats = [
    { icon: '📊', value: analysis.rows_count?.toLocaleString() || 0, label: 'Registros' },
    { icon: '📋', value: analysis.columns_count || 0, label: 'Colunas' },
    { icon: '🎯', value: analysis.target_name || 'N/A', label: 'Target' },
    { icon: '🔢', value: analysis.numeric_columns || 0, label: 'Numéricas' },
    { icon: '🏷️', value: analysis.categorical_columns || 0, label: 'Categóricas' },
    { icon: '🧹', value: analysis.dropped_features_count || 0, label: 'Features Removidas' },
  ];

  return (
    <div style={{
      display: 'grid',
      gridTemplateColumns: 'repeat(6, 1fr)',
      gap: '16px',
      marginBottom: '24px'
    }}>
      {stats.map((stat, index) => (
        <div
          key={index}
          style={{
            background: 'linear-gradient(135deg, #1a1a2e, #16213e)',
            borderRadius: '12px',
            padding: '16px',
            border: '1px solid #1a4a7a',
            textAlign: 'center'
          }}
        >
          <div style={{ fontSize: '28px', display: 'block', marginBottom: '4px' }}>
            {stat.icon}
          </div>
          <div style={{ fontSize: '20px', fontWeight: 600, color: '#4fc3f7' }}>
            {stat.value}
          </div>
          <div style={{ fontSize: '13px', color: '#8899aa' }}>
            {stat.label}
          </div>
        </div>
      ))}
    </div>
  );
};